import React, {Fragment} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import ShareButton from './shareButton';
// import { downloadCanvasImageById } from "../misc/utils";
import HomeMenu from "./homeMenu";
import Analytics from "./../../analytics";
import {showSchedulerPopup, toggleUserPopup} from "../../actions/actionFunctions";
import SaveButton from "./saveButton";
import QuoteButton from "./quoteButton";
import DesignButton from "./designButton";
import {UserPopupTypes} from "../visComponents/constants";
import ScheduleButton from "./scheduleButton";
import MinimizeButton from "./minimizeButton";
import {getCurrentLayout} from "../appLayout";
import {renderMessagePopup} from "../../api/api-popups";
import {saveQuote} from "../../api/server-api";
import Config from "../../config";
import NavigationRequests from "../visComponents/navigation/navigationRequests";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {downloadCSV} from "../../misc/downloadCSV";
import PingPilotButton from "../visComponents/pingPilotButton";
import AIButton from "../ai/aiButton";

class MainButtons extends NavigationRequests {

  static propTypes = {
    goBack: PropTypes.func,
    goToCart: PropTypes.func,
    changeMessageBoxState: PropTypes.func.isRequired,
    resetEverything: PropTypes.func.isRequired,
    canvasId: PropTypes.string,
  };

  handleResetButtonClick = () => {
    Analytics.sendClickEvent("reset-quote-question");
    this.props.changeMessageBoxState({
      visible: true,
      message: "messageBox.resetTitle",
      buttons: [{
        text: "messageBox.buttonNo",
        color: "blue",
        click: () => {
          Analytics.sendClickEvent("reset-quote-cancel");
          this.props.changeMessageBoxState({visible: false});
        }
      }, {
        text: "messageBox.buttonYes",
        color: "green",
        click: () => {
          Analytics.sendClickEvent("reset-quote-yes");
          this.props.changeMessageBoxState({visible: false});
          this.props.resetEverything();
        }
      }]
    });
  };

  handleLoginButtonClick = (userPopupType) => {
    Analytics.sendClickEvent("main-login-button");
    this.props.toggleUserPopup({
      userPopupOpened: true,
      userPopupType
    });
  };

  handleLogOutButtonClick = () => {
    Analytics.sendClickEvent("main-logout-button-question");
    this.props.changeMessageBoxState({
      visible: true,
      message: "messageBox.logoutTitle",
      buttons: [{
        text: "messageBox.buttonNo",
        color: "blue",
        click: () => {
          Analytics.sendClickEvent("main-logout-button-no");
          this.props.changeMessageBoxState({visible: false});
        }
      }, {
        text: "messageBox.buttonYes",
        color: "green",
        click: () => {
          Analytics.sendClickEvent("main-logout-button-yes");
          this.props.changeMessageBoxState({visible: false});
          this.props.toggleUserPopup({
            userPopupOpened: false,
            userIsLoggedIn: false,
            isPhoneNumberValidated: false
          });
        }
      }]
    });
  };

  handleScheduleButtonClick = () => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    Analytics.sendClickEvent('schedule-appointment-main-button');
    if (!this.props.isPhoneNumberValidated) {
      this.handleLoginButtonClick(UserPopupTypes.Schedule);
      return;
    }
    if (fabricatorSettings.enableCalendarForScheduling) {
      this.props.showSchedulerPopup(true)
    } else {
      saveQuote({submit: true, quoteRequestType: QuoteRequestType.ScheduleAnAppointment})
        .then(() => {
          renderMessagePopup("userPopup.messageBox.appointmentRequested");
        });
    }
  };

  getAllFeatures = () => {
    const layout = getCurrentLayout();
    const parents = layout.getFeatures(true); // we need other groups too
    parents.forEach((parent) => {
      parent.relatedItems.forEach(async relItem => {
        await this.checkIfAllFeaturesReceived({part: relItem});
      })
    });
  };

  consoleTableAllFeatures = async () => {
    loaderEnable();
    const layout = getCurrentLayout();
    // console.log("Active Features:", layout.getActiveFeatures(true));
    // console.log("layout.getActiveFeaturesAsObject:", JSON.stringify(layout.getActiveFeaturesAsObject(false, true, true)));
    const parents = layout.getFeatures(true); // we need other groups too
    // console.log("go");
    await this.getAllFeatures();
    // console.log("stop");
    let allFeatures = [
      ["groupName", "sharedFeatureName", "customDisplayName", "metaData", "filters"]
    ];
    parents.forEach((parent) => {
      parent.relatedItems.forEach(relItem => {
        for (let i = 0; i <= relItem.features.length; i++) {
          const feature = relItem.features[i];
          if (feature && allFeatures.every(f => (f.sharedFeatureName !== feature.dbFeature.sharedFeatureName)
            || (f.groupName !== feature.dbFeature.groupName))) {
            allFeatures.push([
              feature.dbFeature.groupName,
              feature.dbFeature.sharedFeatureName,
              feature.dbFeature.customDisplayName,
              JSON.stringify(feature.dbFeature.metaData),
              JSON.stringify(feature.dbFeature.filters)
            ])
          }
        }
      })
    });
    console.log(allFeatures);
    loaderDisable();
    downloadCSV(allFeatures);
  }

  consoleActiveFeatures = () => {
    const layout = getCurrentLayout();
    console.log("Active Features:", layout.getActiveFeatures(true));
    console.log("Active Lead Features:", layout.getActiveNames());
    console.log("layout.getActiveFeaturesAsObject:", JSON.stringify(layout.getActiveFeaturesAsObject(false, true, true)));
    this.consoleTableAllFeatures();
  }

  render() {
    const fabricatorSettings = this.props.fabricatorData.settings;
    const dashboardFramed = Config.isVisualizerManagement();
    const allPagesEnabled = !document.kvConfig.visualizerOnly;
    const quoteEnabled = fabricatorSettings.enableQuote;
    return (
      <Fragment>
        <div className="mainbuttons">
          {this.props.windowWidth < 991 ? (
            <DesignButton handleScheduleButtonClick={this.handleScheduleButtonClick}
                          quoteEnabled={quoteEnabled}
                          handleResetButtonClick={this.handleResetButtonClick}
            />
          ) : null}
          {this.props.windowWidth < 991 || dashboardFramed || (this.props.fabricatorData.checkout && this.props.goToCart && allPagesEnabled) ? null : (
            <SaveButton/>
          )}
          {quoteEnabled ? <QuoteButton/> : null}
          <PingPilotButton design="mainButton"/>
          <ScheduleButton buttonLayoutId="mobileButton"/>
          {(fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId)) ? (
            <button className="mobilebutton mobilebutton--account"
                    onClick={this.props.userIsLoggedIn
                      ? this.handleLogOutButtonClick
                      : () => this.handleLoginButtonClick(UserPopupTypes.Unlock)}>
            <span className="mobilebutton-text">
              <FormattedMessage id={this.props.userIsLoggedIn ? "logOutButton" : "logInButton"}/>
            </span>
            </button>
          ) : null}
          {Config.isDevMode() ? (
            <button className="mobilebutton mobilebutton--settings" onClick={this.consoleActiveFeatures}>
              <span className="mobilebutton-text">EXPORT CSV</span>
            </button>
          ) : null}
          {(fabricatorSettings.showPricing) && this.props.goToCart && allPagesEnabled ? (
            <button className="mobilebutton mobilebutton--cart"
                    onClick={this.props.goToCart}>
              <span className="mobilebutton-text"><FormattedMessage id="cartButton"/></span>
              {this.props.cartItems.length ? (
                <span className="mobilebutton-number">{this.props.cartItems.length}</span>
              ) : null}
            </button>
          ) : null}
          {fabricatorSettings.enableSharing && !dashboardFramed ? <ShareButton/> : null}
          <button className="mobilebutton mobilebutton--reset" onClick={this.handleResetButtonClick}>
            <span className="mobilebutton-text"><FormattedMessage id="resetButton"/></span>
          </button>
          {allPagesEnabled ? <MinimizeButton/> : null}
          {this.props.mobileNav.length && this.props.windowWidth >= 991 ? <HomeMenu/> : null}
          {document.kvConfig.jobId ? <div className="mobilebutton--spacer"/> : null}
        </div>
        <AIButton/>
      </Fragment>

    )
  }
}

const mapStateToProps = (store) => {
  return {
    mobileNav: store.navigationState.mobileNav,
    cartItems: store.cartState.cartItems,
    windowWidth: store.serverState.windowWidth,
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    userIsLoggedIn: store.userState.userIsLoggedIn,
  };
};

export default connect(mapStateToProps, {
  showSchedulerPopup,
  toggleUserPopup
})(MainButtons);
